import type { AlertColor } from '@mui/material';
import apiClient from '@uniqcamp/shared/services/api.service';

export async function openStaticQRPrintPage(
  schoolCode: string,
  schoolName: string,
  gateId: string,
  gateName: string,
  showToast: (severity: AlertColor, message: string) => void
): Promise<void> {
  try {
    const res = await apiClient.get(`/tv-display/${schoolCode}/${gateId}/static-qr`);
    const data = res.data as { gateName?: string; qrCodeImage?: string };
    if (!data.qrCodeImage) { showToast('error', 'Failed to generate QR'); return; }

    const displayGateName = data.gateName || gateName || gateId;
    const w = window.open('', '_blank');
    if (!w) { showToast('error', 'Pop-up blocked. Allow pop-ups and try again.'); return; }

    w.document.write([
      '<!DOCTYPE html><html><head>',
      `<title>QR \u2013 ${displayGateName}</title>`,
      '<style>',
      '  body { margin: 0; display: flex; flex-direction: column; align-items: center; justify-content: center;',
      '         min-height: 100vh; font-family: sans-serif; text-align: center; padding: 16px; box-sizing: border-box; }',
      '  img  { width: 100%; max-width: 600px; }',
      '  h1   { margin: 0 0 8px; font-size: 2rem; }',
      '  p    { margin: 0 0 12px; color: #555; font-size: 1.1rem; }',
      '  @media print { img { max-width: 100%; } body { padding: 0; } }',
      '</style>',
      '</head><body>',
      `<h1>${schoolName}</h1>`,
      `<p>Gate: ${displayGateName}</p>`,
      `<img src="${data.qrCodeImage}" alt="QR Code" />`,
      '<p style="margin-top:16px;font-size:0.9rem;color:#888">Scan this QR code with the parent app to request dispersal</p>',
      '</body></html>',
    ].join('\n'));
    w.document.close();
  } catch {
    showToast('error', 'Failed to load QR code');
  }
}
